// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /block/list.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeBlockListBody,
  typeBlockListOutput200,
} from "../../sdk/block/postBlockList";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildBlockListQueryKey(payload: typeBlockListBody): string[] {
  const queryKeySegments: string[] = [];
  if (typeof payload.cursor !== "undefined") {
    queryKeySegments.push(`cursor:${JSON.stringify(payload.cursor)}`);
  }
  if (typeof payload.limit !== "undefined") {
    queryKeySegments.push(`limit:${JSON.stringify(payload.limit)}`);
  }
  return ["post:block:blockList", "svc:profile-api", ...queryKeySegments];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeBlockListOutput200,
    unknown,
    typeBlockListOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useBlockList(
  payload: typeBlockListBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildBlockListQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postBlockList(payload),
    ...resolvedOptions,
  });
}
